import React from "react";
import {Card, CardContent, Typography} from "@material-ui/core";
import "./InfoBox.css";

function InfoBox({textColor, title, cases, total, active, ...prop}) {
  return (
    <Card
      onClick={prop.onClick}
      className={`infoBox ${
        (active === "cases" && "infoBox--cases") ||
        (active === "recovered" && "infoBox--recovered") ||
        (active === "deaths" && "infoBox--deaths")
      } `}
    >
      <CardContent>
        <Typography className="infoBox__title" color="textSecondary">
          {title}
        </Typography>

        <h2 className={`infoBox__cases text-${textColor}`}>{cases}</h2>

        <Typography className="infoBox__total" color="textSecondary">
          {total} Total
        </Typography>
      </CardContent>
    </Card>
  );
}

export default InfoBox;
